import { render, staticRenderFns } from "./healthManagementSpecialist.vue?vue&type=template&id=006abc48&"
import script from "./healthManagementSpecialist.vue?vue&type=script&lang=js&"
export * from "./healthManagementSpecialist.vue?vue&type=script&lang=js&"
import style0 from "./healthManagementSpecialist.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports